import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import config from '../conf/config';
import { getCurrentUserToken } from '../data/firebase';

const httpLink = createHttpLink({
  uri: config.graphql.serverUrl,
});

const authLink = setContext(async (_, { headers }) => {
  const token = await getCurrentUserToken();
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  // uri: config.graphql.serverUrl,
  cache: new InMemoryCache(),
});

export default client;
